import { Box, CoreButton, Heading, Text, useTheme } from '@vitvio/design-system';
import { ErrorPageIcon, VitvioLogo } from './Icons';
import { useUserId, dayjs } from '@vitvio/helpers';
import { PrimaryButton } from './PrimaryButton';
import { useBuildMetadata } from '@vitvio/build-metadata';
import { SupportText } from './SupportText';
interface GenericErrorPageProps {
  children?: React.ReactNode;
  errorHeadingText?: string;
}
export const GenericErrorPage = ({
  children = <DefaultErrorPageInfo />,
  errorHeadingText = 'common:error.generic',
}: GenericErrorPageProps) => {
  const { version } = useBuildMetadata();
  const { getColor, getRadius, getSpacing } = useTheme();
  const userId = useUserId();
  const currentDateTime = new Date();
  const currentDateTimeString = dayjs(currentDateTime).format('YYYY-MM-DD hh:mm:ss a');
  return (
    <Box
      bg={getColor('bg.sunken')}
      textAlign="center"
      height="100vh"
      display="flex"
      flexDirection="column"
      alignItems="center"
      paddingBottom={10}
    >
      <Box width={'100%'} display={'flex'} flexDirection={'column'} alignItems={'center'} justifyContent={'center'}>
        <Box p={'60px 0px 60px 0px'}>
          <VitvioLogo color={getColor('fg.muted')} />
        </Box>
      </Box>
      <Box
        width={'100%'}
        height={'100%'}
        display={'flex'}
        flexDirection={'column'}
        alignItems={'center'}
        justifyContent={'center'}
        bg={getColor('bg.sunken')}
        gap={getSpacing('4')}
      >
        <Box
          width={'575px'}
          paddingX={getSpacing('6')}
          paddingY={getSpacing('10')}
          boxShadow="lg"
          borderRadius={getRadius('lg')}
          bg={getColor('bg.overlay')}
          shadow="base"
        >
          <Box paddingBottom={getSpacing('10')}>
            <ErrorPageIcon color={getColor('fg.muted')} />
          </Box>
          <Text
            // TODO: All of these attributes need to be derived from the font attribute, not hardcoded
            // font="M_SemiBold"
            fontSize="xl"
            fontWeight={'semibold'}
            // TODO: This needs to equal 32px instead
            lineHeight={6}
            marginBottom={4}
            path={errorHeadingText}
            color={getColor('fg')}
          />
          <Box display="flex" flexDirection="column" gap={getSpacing('6')} alignItems="center">
            {children}
          </Box>
        </Box>

        <Box bg="inherit" w={'100%'} paddingBottom="23px" display="flex" flexDirection="column" gap={getSpacing('2')}>
          <Text
            path="common:info.userID"
            value={{ userId }}
            // TODO: All of these attributes need to be derived from the font attribute, not hardcoded
            fontSize="xs"
            lineHeight={4}
            fontWeight="500"
            color={getColor('fg.muted')}
          />
          <Text fontSize="xs" lineHeight={4} fontWeight="500" color={getColor('fg.muted')}>
            {currentDateTimeString}
          </Text>
          <Text
            path="common:info.apiVersion"
            value={{ apiVersion: version }}
            fontSize="xs"
            lineHeight={4}
            fontWeight="500"
            color={getColor('fg.muted')}
          />
        </Box>
      </Box>
      <SupportText />
    </Box>
  );
};

function DefaultErrorPageInfo() {
  return (
    <>
      <Text path="common:error.genericDescription" whiteSpace="pre-line" />
      <CoreButton
        label="common:button.backToHomepage"
        onClick={() => (window.location.href = '/')}
        type="primary"
        size={'lg'}
        width="auto"
      />
    </>
  );
}
